export const menu = {
  stock: 'Warehouse-in(Storing)',
  ship: 'Warehouse-out(Transfer)',
  lend: 'Shipping for customer',
  return: 'Return from customer',
  defective: 'Inventory(NG Items)',
  lostItem: 'Inventory(Lost Items)',
  productDetail: 'Product detail',
}
